// SunDrip™ — UI scripts

var _modalProductPromise = null;

function openModal(name, handle) {
  document.querySelector('.modal-name').textContent = name;
  _modalProductPromise = null;
  if (handle) {
    var root = (window.TCRoutes && window.TCRoutes.root || '/').replace(/\/$/, '');
    _modalProductPromise = fetch(root + '/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Could not load product.');
        return r.json();
      });
  }
  document.querySelector('.modal-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  document.querySelector('.modal-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

document.querySelector('.modal-overlay').addEventListener('click', function(e) {
  if (e.target === this) closeModal();
});

function selSize(btn) {
  document.querySelectorAll('.modal-size').forEach(function(b) { b.classList.remove('sel'); });
  btn.classList.add('sel');
}

function addToCartModal() {
  var sizeBtn = document.querySelector('.modal-size.sel');
  if (!sizeBtn) {
    alert('Please select a size first.');
    return;
  }
  if (!_modalProductPromise) {
    alert('Could not load product.');
    return;
  }
  var buyBtn = document.querySelector('.modal-buy');
  if (buyBtn) { buyBtn.disabled = true; buyBtn.dataset.label = buyBtn.textContent; buyBtn.textContent = 'Adding…'; }
  var size = sizeBtn.dataset.size;

  _modalProductPromise
    .then(function (product) {
      var variant = product.variants.find(function (v) {
        return v.options.indexOf(size) !== -1 || v.title === size;
      });
      if (!variant) throw new Error('Size ' + size + ' is not available for this product.');
      if (!variant.available) throw new Error('Size ' + size + ' is sold out.');
      var cartAdd = (window.TCRoutes && window.TCRoutes.cartAdd) || '/cart/add';
      return fetch(cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    })
    .then(function () {
      var cartUrl = ((window.TCRoutes && window.TCRoutes.cart) || '/cart') + '.js';
      return fetch(cartUrl).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      var count = document.querySelector('.cart-count');
      if (count) count.textContent = cart.item_count;
      closeModal();
      if (window.location.pathname.indexOf('/cart') !== -1) window.location.reload();
    })
    .catch(function (err) {
      alert(err.message || 'Could not add to cart.');
    })
    .finally(function () {
      if (buyBtn) { buyBtn.disabled = false; buyBtn.textContent = buyBtn.dataset.label || 'Add to Cart'; }
    });
}

// Filter tabs — highlights active tab only
function filterProducts(cat, btn) {
  document.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
  btn.classList.add('active');
}

// Collection sort — reload with sort_by param
function sortCollection(value) {
  var url = new URL(window.location.href);
  if (value) {
    url.searchParams.set('sort_by', value);
  } else {
    url.searchParams.delete('sort_by');
  }
  window.location.href = url.toString();
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeModal();
});

document.addEventListener('DOMContentLoaded', function() {
  var defaultSize = document.querySelector('.modal-size[data-size="M"]');
  if (defaultSize) defaultSize.classList.add('sel');
});
